import React from 'react'
import { motion } from 'framer-motion'
import { useApp } from '../contexts/AppContext'
import SafeIcon from '../common/SafeIcon'
import * as FiIcons from 'react-icons/fi'
import * as SiIcons from 'react-icons/si'

const { FiHeart, FiCode } = FiIcons
const { SiThreads, SiInstagram, SiFacebook } = SiIcons

const socialLinks = [
  {
    href: 'https://www.threads.com/@homy.hk',
    icon: SiThreads,
    label: 'Threads',
    color: 'hover:text-gray-900 dark:hover:text-white'
  },
  {
    href: 'https://www.instagram.com/homy.hk',
    icon: SiInstagram,
    label: 'Instagram',
    color: 'hover:text-pink-500'
  },
  {
    href: 'https://www.facebook.com/profile.php?id=61578745554661',
    icon: SiFacebook,
    label: 'Facebook',
    color: 'hover:text-blue-600'
  }
]

const Footer = () => {
  const { currentLang, translations } = useApp()
  const currentYear = new Date().getFullYear()

  return (
    <motion.footer
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.8 }}
      className="py-6 sm:py-8 text-center text-gray-500 dark:text-gray-400 border-t border-gray-200 dark:border-gray-800"
    >
      <div className="max-w-4xl mx-auto px-4 space-y-3 sm:space-y-4">
        {/* Copyright */}
        <p className="text-xs sm:text-sm">
          {translations.footerCopyright[currentLang].replace('2025', currentYear)}
        </p>

        {/* Developer Info + Social Links - Same Row */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-xs">
          {/* Developer Info */}
          <div className="flex items-center gap-1 sm:gap-2">
            <SafeIcon icon={FiCode} className="w-3 h-3 text-blue-500" />
            <span className="text-gray-400 dark:text-gray-500">
              {translations.footerMadeBy[currentLang]}
            </span>
            <SafeIcon icon={FiHeart} className="w-3 h-3 text-red-500 animate-pulse" />
            <a
              href={translations.footerCompanyUrl[currentLang]}
              target="_blank"
              rel="noopener noreferrer"
              className="text-purple-600 dark:text-purple-400 font-medium hover:text-purple-700 dark:hover:text-purple-300 transition-colors duration-200"
            >
              {translations.footerCompany[currentLang]}
            </a>
          </div>

          {/* Divider */}
          <span className="hidden sm:inline text-gray-300 dark:text-gray-700">|</span>

          {/* Social Links */}
          <div className="flex items-center gap-3">
            {socialLinks.map(({ href, icon, label, color }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                className={`text-gray-400 dark:text-gray-500 transition-colors duration-200 ${color}`}
              >
                <SafeIcon icon={icon} className="w-3.5 h-3.5" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </motion.footer>
  )
}

export default Footer